//reducer to handle the slides
import { 
  FETCH_SLIDES_REQUEST,
  FETCH_SLIDES_SUCCESS,
  FETCH_SLIDES_FAILURE
} from '../actions/SlidesActions';

const initialState = {
  slides: [],
  loading: false,
  error: null
};

const slidesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SLIDES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SLIDES_SUCCESS:
      return { ...state, slides: action.payload, loading: false, error: null };
    case FETCH_SLIDES_FAILURE:
      return { ...state, slides: [], loading: false, error: action.payload };
    default:
      return state;
  }
};

export default slidesReducer;

